import PersonaPage from "./PersonaPage";
import { questionsGrandparent } from "./questions";

const faq = [
  {
    q: "Wie schreibt man eine Trauerrede für den Opa?",
    a: "Bei Großvätern trägt oft eine Werkstattgeschichte, ein Spaziergang oder ein Satz eine ganze Rede. Beginnen Sie dort — nicht bei den Daten, sondern bei einer Geste.",
  },
  {
    q: "Ich bin ein Enkelkind — passt eine Rede von mir?",
    a: "Sehr gut sogar. Eine Enkelrede zeigt einen Opa, den nur Enkelkinder kennen: mit mehr Geduld, mit weniger Regeln, mit Zeit. Das ist ein wertvoller Blick.",
  },
  {
    q: "Wie lang darf eine Trauerrede für den Großvater sein?",
    a: "Kurz und klar hält bei Großvätern oft am längsten. Ein Bild, ein Dank, ein Satz zur Zukunft — mehr braucht es meist nicht. Wir helfen, das Wesentliche zu finden.",
  },
  {
    q: "Was, wenn wir uns wenig gesehen haben?",
    a: "Auch Distanz darf eine Rede tragen — als Anerkennung dafür, dass es ihn gab und dass er auf seine Weise da war. Wir formulieren das behutsam.",
  },
  {
    q: "Wie schnell erhalten wir den Entwurf?",
    a: "Sofort nach Zahlung. Der Entwurf erscheint auf dem Bildschirm, als PDF und zusätzlich per E-Mail — meist in unter zwei Minuten.",
  },
];

const related = [
  { label: "Trauerrede für die Großmutter", to: "/trauerrede-oma" },
  { label: "Trauerrede für den Vater", to: "/trauerrede-vater" },
  { label: "Trauerrede für den Bruder", to: "/trauerrede-bruder" },
];

export default function TrauerredeOpa() {
  return (
    <PersonaPage
      slug="trauerrede-opa"
      metaTitle="Trauerrede für den Opa schreiben — persönlich für den Großvater | Oratiorede"
      metaDescription="Eine persönliche Trauerrede für den Opa. Aus Werkstattgeschichten, Spaziergängen und geduldigen Nachmittagen entsteht in acht Fragen ein warmer Entwurf. Ab 29 €."
      eyebrow="Trauerrede · Opa · Großvater"
      headline={
        <>
          Eine Trauerrede für den Opa.
          <br />
          <span className="italic text-umber">Seine Werkstatt. Seine Zeit. Seine Stimme.</span>
        </>
      }
      intro="Ein Großvater ist der Mensch, der die Uhr aus dem Zimmer nimmt, wenn ein Enkelkind zu Besuch ist. Ein behutsamer erster Entwurf für Ihren Opa — aus acht ruhigen Fragen und den Nachmittagen, die es ohne ihn nicht gegeben hätte."
      heroImage="https://images.unsplash.com/photo-1518709594023-6eab9bab7b23?w=1920&q=80"
      heroImageAlt="Alte Werkzeuge auf einer hölzernen Werkbank im warmen Licht — Sinnbild einer Trauerrede für den Opa"
      questions={questionsGrandparent}
      exampleQuote={
        <>
          „Er hatte in seiner Werkstatt keine Uhr. Sagte er zumindest. Ich habe später verstanden,
          dass er einfach entschieden hatte, dort keine Zeit vergehen zu lassen — nicht für sich
          und schon gar nicht für uns. Wenn ich heute versuche, jemandem wirklich zuzuhören, dann
          nehme ich unbewusst seine Haltung ein. So bleibt er.“
        </>
      }
      faq={faq}
      related={related}
    />
  );
}
